module.exports = __webpack_public_path__ + "img/M.e3b6e976.png";